/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UnitAllOfReservationPayments } from './UnitAllOfReservationPayments';
import {
    UnitAllOfReservationPaymentsFromJSON,
    UnitAllOfReservationPaymentsFromJSONTyped,
    UnitAllOfReservationPaymentsToJSON,
    UnitAllOfReservationPaymentsToJSONTyped,
} from './UnitAllOfReservationPayments';

/**
 * 
 * @export
 * @interface UnitAllOfReservation
 */
export interface UnitAllOfReservation {
    /**
     * 
     * @type {string}
     * @memberof UnitAllOfReservation
     */
    clientName: string;
    /**
     * 
     * @type {Array<UnitAllOfReservationPayments>}
     * @memberof UnitAllOfReservation
     */
    payments: Array<UnitAllOfReservationPayments>;
}

/**
 * Check if a given object implements the UnitAllOfReservation interface.
 */
export function instanceOfUnitAllOfReservation(value: object): value is UnitAllOfReservation {
    if (!('clientName' in value) || value['clientName'] === undefined) return false;
    if (!('payments' in value) || value['payments'] === undefined) return false;
    return true;
}

export function UnitAllOfReservationFromJSON(json: any): UnitAllOfReservation {
    return UnitAllOfReservationFromJSONTyped(json, false);
}

export function UnitAllOfReservationFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnitAllOfReservation {
    if (json == null) {
        return json;
    }
    return {
        
        'clientName': json['clientName'],
        'payments': ((json['payments'] as Array<any>).map(UnitAllOfReservationPaymentsFromJSON)),
    };
}

export function UnitAllOfReservationToJSON(json: any): UnitAllOfReservation {
    return UnitAllOfReservationToJSONTyped(json, false);
}

export function UnitAllOfReservationToJSONTyped(value?: UnitAllOfReservation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientName': value['clientName'],
        'payments': ((value['payments'] as Array<any>).map(UnitAllOfReservationPaymentsToJSON)),
    };
}

